import Cookies from 'js-cookie';
import {
  isBrandPlp,
  isCollectionPlp,
  isSearchPage,
  isTagsPlp,
  isPromotionPlp,
  parseAlgoliaUrl,
} from './helpers';
import { urlIsKnownFilter } from './urlIsKnownFilter';
import { getCategorySlugsFromUrl } from './getCategorySlugsFromUrl';
import { slugify } from '@utils/url';

// These are FR from the url, but Digi Merch find it more useful to have them in EN
// so they're able to copy rules across EN/FR indexes
const forceFRtoEn = (rule: string) => {
  const frSlugs: { [key: string]: string } = {
    plp_hommes: 'plp_mens',
    plp_femmes: 'plp_womens',
    plp_unisexe: 'plp_unisex',
    plp_enfants: 'plp_kids',
    plp_aubaines: 'plp_deals',
    plp_liquidation: 'plp_clearance',
    plp_economisez: 'plp_sale',
    plp_nouveau: 'plp_new-arrivals',
  };
  return frSlugs[rule] || rule;
};

export const getAlgoliaRuleContexts = (url: string) => {
  const pathname = new URL(url).pathname;
  const locale = pathname.split('/')[1] === 'fr' ? 'fr' : 'en';
  const { categorySlug } = getCategorySlugsFromUrl(pathname, locale);

  const { brandCategoryFilter, isTaxonomyPlp } = parseAlgoliaUrl(
    pathname,
    locale
  );

  const { categoryFilters } = getCategorySlugsFromUrl(pathname, locale);
  const activeFilters = categoryFilters
    ? categoryFilters.map((filter) => {
        return forceFRtoEn(`plp_${filter}`);
      })
    : [];

  const baseCategory =
    isTaxonomyPlp && categorySlug?.length
      ? `plp_${slugify(categorySlug[0])}`
      : isCollectionPlp(pathname)
      ? `plp_${slugify(categorySlug[1])}`
      : '';

  const rules = [
    ...(isSearchPage(url) ? ['context_search'] : ['context_browse']),
    ...(urlIsKnownFilter(url, locale) ? ['context_filter'] : []),
    ...(isTaxonomyPlp ? ['plp_category'] : []),
    ...(isCollectionPlp(pathname) ? ['plp_collection'] : []),
    ...(isBrandPlp(url) ? ['plp_brand'] : []),
    ...(brandCategoryFilter ? ['plp_brand_category'] : []),
    ...(isPromotionPlp(url, locale) ? ['plp_promotion'] : []),
    ...(isTagsPlp(url) ? ['plp_tags'] : []),
    ...(activeFilters ? activeFilters : []),
    ...(baseCategory ? [baseCategory] : []),
  ];

  if (Cookies.get('algoliaDebug')) {
    console.log('algolia: rulesContext', rules);
  }

  return rules;
};
